import _default from './Reveal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/Reveal/index.js
// module id = 878
// module chunks = 0